import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

const { PROJECTS_API_URL } = CONSTANT

const getProjects = async (): Promise<{
	status: number
	body: Array<object>
}> => {
	const response = await fetchWithAuthorizationHeader(`${PROJECTS_API_URL}`)
	if (response.status !== 200) {
		return {
			status: response.status,
			body: []
		}
	}
	return response.json()
}

export default getProjects
